import { render } from "./EntityExtractionModal.vue?vue&type=template&id=1fa2660c&scoped=true"
import script from "./EntityExtractionModal.vue?vue&type=script&lang=js"
export * from "./EntityExtractionModal.vue?vue&type=script&lang=js"

import "./EntityExtractionModal.vue?vue&type=style&index=0&id=1fa2660c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa2660c"]])

export default __exports__